var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardSvg2Black(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 22,
    height: 22,
    transform: "translate(-0.335)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4",
    "data-name": "Mask Group 4",
    transform: "translate(0.335)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(-0.382 0.823)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M13.127,12.687A3.557,3.557,0,1,0,9.533,9.093,3.6,3.6,0,0,0,13.127,12.687ZM13.053,7.04h0A2.128,2.128,0,0,1,15.18,9.167a2.09,2.09,0,0,1-4.18,0A2.114,2.114,0,0,1,13.053,7.04Z",
    transform: "translate(-2.2 -3.112)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M23.98,12.247a7.261,7.261,0,0,0-5.133-1.833H18.26a4.889,4.889,0,0,1-.66,1.54,7.115,7.115,0,0,1,1.247-.073,6.1,6.1,0,0,1,3.887,1.173v5.28H24.2V12.467l-.22-.22Z",
    transform: "translate(-2.2 -3.112)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M17.16,5.72a1.791,1.791,0,0,1,3.3,1.393,1.83,1.83,0,0,1-1.613,1.1,1.248,1.248,0,0,1-.513-.073,5.2,5.2,0,0,1,.073,1.027v.44c.147,0,.293.073.44.073a3.264,3.264,0,1,0,.073-6.527,3.145,3.145,0,0,0-2.787,1.613,3.131,3.131,0,0,1,1.027.953Z",
    transform: "translate(-2.2 -3.112)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M8.8,12.027a4.889,4.889,0,0,1-.66-1.54H7.553a7.546,7.546,0,0,0-5.133,1.76l-.22.22v5.867H3.667v-5.28A6.234,6.234,0,0,1,7.553,11.88,6.458,6.458,0,0,1,8.8,12.027Z",
    transform: "translate(-2.2 -3.112)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M7.553,9.607a.93.93,0,0,0,.44-.073v-.44a4.51,4.51,0,0,1,.073-1.027,1.248,1.248,0,0,1-.513.073,1.76,1.76,0,1,1,0-3.52A1.853,1.853,0,0,1,9.24,5.72a7.3,7.3,0,0,1,1.1-1.027A3.258,3.258,0,1,0,7.553,9.607Z",
    transform: "translate(-2.2 -3.112)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M19.14,16.647l-.147-.22a7.4,7.4,0,0,0-5.72-2.493A7.554,7.554,0,0,0,7.48,16.427l-.147.22V22.22A1.236,1.236,0,0,0,8.58,23.467h9.387a1.285,1.285,0,0,0,1.247-1.247V16.647ZM17.673,22H8.8V17.16a6.258,6.258,0,0,1,4.473-1.76,5.914,5.914,0,0,1,4.4,1.76Z",
    transform: "translate(-2.2 -3.112)",
    fill: "#000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardSvg2Black);
export default __webpack_public_path__ + "static/media/card-svg-2-black.ff1a89c49efaca256e9478f86235ebec.svg";
export { ForwardRef as ReactComponent };